"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.stripe.info': 'Completa il pagamento utilizzando Stripe Elements qui sotto.',
    'payment.stripe.clientSecret': 'Client Secret',
    'payment.stripe.noClientSecret': 'Nessun Client Secret Stripe disponibile',
};
